<template>
  <el-dialog
    top="0"
    custom-class="tip-dialog"
    :visible.sync="visible"
    :show-close="false"
    width="480px"
    center
  >
    <!-- 自定义头部 -->
    <div slot="title" class="custom-dialog-title">
      <i class="el-icon-close close-icon" data-io-click="tracker"  @click="handleClose($event)"></i>
    </div>
    <div class="tip-dialog-content">
      <img src="@/assets/images/question-icon.png" alt="" />
      <span>{{ title }}</span>
    </div>
    <div class="tip-dialog-footer">
      <div class="btn cancel-btn" data-io-click="tracker"  @click="handleClose($event)">取消</div>
      <div class="btn confirm-btn" data-io-click="tracker"  @click="handleConfirm($event)">确定</div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "TipDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose(event) {
      if (event) {
        event.stopPropagation();
      }
      this.$emit("close");
    },
    handleConfirm(event) {
      if (event) {
        event.stopPropagation();
      }
      this.$emit("confirm");
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .tip-dialog {
  .el-dialog__header {
    border-bottom: none;
    padding: 16px;
    height: auto;
    // color:
  }

  .custom-dialog-title {
    position: relative;
    width: 100%;
    height: 20px;

    .close-icon {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 20px;
      font-weight: 600;
      cursor: pointer;
      color: #666666;

      &:hover {
        color: #409eff;
      }
    }
  }

  .tip-dialog-content {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    img {
      width: 86px;
      height: 86px;
      margin-bottom: 6px;
      display: block;
    }
    span {
      font-size: 16px;
      display: block;
      color: #1a1a1a;
      margin-bottom: 36px;
    }
  }
  .tip-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    .btn {
      width: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      text-align: center;
      font-size: 14px;
      border-radius: 6px;
      cursor: pointer;
      &.cancel-btn {
        border: 1px solid #e2e2e2;
        color: #7e7e7e;
        margin-right: 16px;
        &:hover {
          border: 1px solid #0057ff;
          background: #e5f7fe;
          color: #0057ff;
        }
      }
      &.confirm-btn {
        background: #0057ff;
        color: #fff;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
